
const 	$ = jQuery;
const	$general_card_read_more	= $('.js-general-card-read-more');

if ( $general_card_read_more.length ) {

	$general_card_read_more.each( function() {

		const 	$current_element = $(this),
				$slide_target 	 = $current_element.prev(),
				read_x 		  	 = $current_element.find('.js-general-card-read-x');

		$slide_target.css({
			'display' : 'none'
		});

		$current_element.removeClass('hidden');

	});

	$general_card_read_more.on('click', function () {

		const 	$current_element = $(this),
				$slide_target 	 = $current_element.prev(),
				read_x 		  	 = $current_element.find('.js-general-card-read-x');

		$slide_target.slideToggle().toggleClass('is-open');

		read_x.html( $slide_target.hasClass('is-open') ? 'Less' : 'More' );

	});

}